// 首页、专项练习数据报告、每日任务详情、练习报告、全部解析详情、错题解析详情、做题详情、打卡详情（众合app）、众合名师详情
// 主观题、客观题

import System from '@/store'
import { getBuryPoints } from '@/utils/buryPoints'

const PATHNAME_TO_TITLE_MAP = new Map([
  ['/', '首页'],
  ['/fakao', '首页'],
  ['/fakao/', '首页'],
  ['/fashuo', '首页'],
  ['/fashuo/', '首页'],
  ['/w/dataReport', '专项练习数据报告'],
  //   下面这四个都是  是pageView事件
  ['/obt/analysis', '全部解析详情+错题解析详情+练习报告'],
  ['/w/answerAnalysis', '全部解析详情+错题解析详情+练习报告'],
  ['/w/myWrongQuestion', '错题解析详情'],
  ['/w/reciteBrushQuestions', '做题详情'],
  ['/w/exerciseFashuo', '做题详情'],
  ['/w/sujiQuestion', '做题详情'],
  ['/w/mokao/intelligentTopic', '做题详情'],
  ['/obt', '做题详情'],
  // ['', '全部解析详情'],
  // ['', '错题解析详情'],
  // ['', '做题详情'],
  ['/fakao/teacher', '众合名师列表'],
  ['/fashuo/teacher', '众合名师列表']
])

export const getPageTitle = (pathName) => {
  for (let key of PATHNAME_TO_TITLE_MAP.keys()) {
    if ((typeof key === 'string') && Object.is(key, pathName)) {
      return PATHNAME_TO_TITLE_MAP.get(pathName)
    }
    if (Object.prototype.toString.call(key) === '[object RegExp]' && key.test(pathName)) {
      return PATHNAME_TO_TITLE_MAP.get(key)
    }
  }
}
export const getPageTitleByPathName = () => {
  return getPageTitle(window.location.pathname)
}

/**
 * 发送pv的方式有两种
 * 需要再请求接口之后，获取参数，发送pv
 * 不需要任何数据，自动发pv，
 */
// 手动发pv的页面
export const MANUALLY_SEND_PV_MAP = ['/obt', '/w/dataReport', '/obt/analysis', '/w/exerciseFashuo', '/w/sujiQuestion', '/w/reciteBrushQuestions', '/w/answerAnalysis', '/w/mokao/intelligentTopic']
export const AUTO_SEND_PV_MAP = ['/fakao/', '/fakao', '/fashuo/', '/', '/fakao/teacher', '/fashuo/teacher']
export const verifySendPV = () => {
  setTimeout(() => {
    if (AUTO_SEND_PV_MAP.some((item) => window.location.pathname === item)) {
      sendPageView({ manually_send_pv_map: MANUALLY_SEND_PV_MAP })
    }
  }, 100)
}
export const sendPageView = ({ title, manually_send_pv_map = [] } = {}) => {
  if (manually_send_pv_map.some((item) => window.location.href.includes(item))) {
    return
  }
  // 手动发的
  const {
    primaryCatagory,
    fakaoQuestionType,
    totalNumber,
    masteryDegree,
    numberCompletedQuestions,
    practiseFunction,
    secondaryDirectory,
    secondaryCatagory,
    firstDirectory
  } = getBuryPoints()
  System.sensors.quick('autoTrackSinglePage', {
    appPageTitle: () => {
      return title || getPageTitleByPathName()
    },
    primaryCatagory: () => {
      return !!primaryCatagory && primaryCatagory || undefined
    },
    firstDirectory: () => {
      return !!firstDirectory && firstDirectory || undefined
    },
    // 二级分类
    secondaryCatagory: () => {
      return !!secondaryCatagory && secondaryCatagory || undefined
    },
    // 二级目录
    secondaryDirectory: () => {
      return !!secondaryDirectory && secondaryDirectory || undefined
    },
    // 刷题功能区
    practiseFunction: () => {
      return !!practiseFunction && practiseFunction || undefined
    },
    // 已完成题目数
    numberCompletedQuestions: () => {
      return !!numberCompletedQuestions && numberCompletedQuestions || undefined
    },
    // 掌握程度 1-5
    masteryDegree: () => {
      return !!masteryDegree && masteryDegree || undefined
    },
    // 题集总题目数量
    totalNumber: () => {
      return !!totalNumber && totalNumber || undefined
    },
    fakaoQuestionType: () => {
      return !!fakaoQuestionType && fakaoQuestionType || undefined
    }
  })
}
